import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import { ArrowLeft } from 'lucide-react'
import AboutHero from '../../components/About/AboutHero'
import WhoWeAre from '../../components/About/WhoWeAre'
import Partners from '../../components/About/Partners'
import ContactCTA from '../../components/About/ContactCTA'
import NewsletterCTA from '../../components/About/NewsletterCTA'
import Footer from '../../components/landing/Footer'

const About = () => {
  useEffect(()=>{
    window.scrollTo(0,0);
  },[])

  const handleBack = () => {
    window.history.back();
  };
  
  return (
    <div>
      {/* Back Button */}
      <div className="fixed top-24 left-4 z-50">
        <motion.button
          onClick={handleBack}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="flex items-center gap-2 px-4 py-2 bg-white/90 backdrop-blur-sm border border-gray-200 rounded-xl shadow-lg hover:bg-white hover:shadow-xl transition-all duration-300"
        >
          <ArrowLeft className="w-4 h-4 text-gray-600" />
          <span className="text-sm font-medium text-gray-700">Back</span>
        </motion.button>
      </div>
      <AboutHero />
      <WhoWeAre />
      <Partners />
      <ContactCTA />
      <NewsletterCTA />
      <Footer />
    </div>
  )
}

export default About